 <template>
  <div class="my-aside">
    <div class="side-btn-box" :class="{'side-btn-box-unfold':!sideCollapse,}" @click="toggleSide">
      <i :class="{'el-icon-s-unfold':sideCollapse,'el-icon-s-fold':!sideCollapse}"></i>
    </div>

    <el-menu
      active-text-color="#409EFF"
      :router="true"
      :collapse="sideCollapse"
      mode="vertical"
      class="el-menu-vertical-demo"
      :default-active="defaultActive"
      @select="selectHandler"
    >
      <!-- 这里先将一级菜单生成，防止调用递归子菜单时多一个根div，影响样式 -->
      <template v-for="(value,index) in this.pMenuList">
        <el-submenu
          :index="value.Url=='#'?value.Url+index:value.Url"
          v-if="hasChild(value.ID)"
          :key="value.ID"
        >
          <template slot="title">
            <i :class="value.Icon"></i>
            <span slot="title">{{value.Name}}</span>
          </template>
          <MyMenu :pID="value.ID"></MyMenu>
        </el-submenu>
        <el-menu-item :index="value.Url=='#'?value.Url+index:value.Url" v-else :key="value.ID">
          <i :class="value.Icon"></i>
          <span slot="title">{{value.Name}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>
<script>
import MyMenu from "./Menu"; //引入子菜单组件

export default {
  components: {
    MyMenu,
  },
  data() {
    return {
      sideCollapse: false,
      pMenuList: [],
      defaultActive: "",
    };
  },
  methods: {
    toggleSide() {
      this.sideCollapse = !this.sideCollapse;
    },
    hasChild(id) {
      let that = this;
      let tempMenuList = this.$store.state.menuData.filter(function (m) {
        return m.ParentID == id;
      });
      return tempMenuList.length > 0;
    },
    selectHandler(index, indexPath) {
      this.$store.commit("saveCurLeftMenu", index);
    },
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      that.pMenuList = that.$store.state.menuData.filter((item) => {
        return item.ParentID == that.$store.state.leftMenuPID; //一级菜单父id为"0"
      });
      that.$nextTick(() => {
        let match = window.sessionStorage.getItem("curLeftMenu");
        that.defaultActive = match;
      });
    });
  },
  watch: {
    "$store.state.leftMenuPID": function (newVal, oldVal) {
      let that = this;
      that.$nextTick(() => {
        that.pMenuList = that.$store.state.menuData.filter((item) => {
          return item.ParentID == newVal; //一级菜单父id为"0"
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.el-menu-vertical-demo {
  height: 100%;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

.my-aside {
  display: flex;
  flex-direction: column;
}
.side-btn-box {
  flex-shrink: 0;
  width: 64px;
  height: 30px;
  box-sizing: border-box;
  // border-right: solid 1px #e6e6e6;
  background: #fff;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 0.3s ease-in-out, background 0.3s;
}
.side-btn-box:hover {
  background: #ecf5ff;
}
.side-btn-box-unfold {
  width: 200px;
}
.side-btn-box i {
  font-size: 20px;
}

.el-submenu.is-active i {
  color: inherit;
}

.el-submenu__title {
  font-size: 16px;
}

/* 未选中时的颜色继承title颜色，分为有子菜单和没有子菜单时 */

.el-submenu__title i {
  color: inherit;
}

.el-menu-item {
  font-size: 16px;
}

.el-menu-item i {
  color: inherit;
}

.el-submenu.is-active i {
  color: inherit;
}
</style>